/**
 * How long a failed request waited, written on the error as `elapsedMs`.
 *
 * `classifyApiError` needs it because the load balancer's 504 arrives without
 * CORS headers: the browser hides the status, and a request that waited a
 * minute for it looks exactly like one that found no server at all.
 */

/** For a request interceptor. */
export const markRequestStart = (config) => {
  config.startedAt = Date.now();
  return config;
};

/** For a response interceptor's error handler, before anything classifies the error. */
export const markRequestElapsed = (error) => {
  const startedAt = error?.config?.startedAt;
  if (startedAt) error.elapsedMs = Date.now() - startedAt;
  return error;
};
